import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "entity-wrapper",
  ref: "entity_wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"none"} }, /*#__PURE__*/_toDisplayString(' '), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_clipboard = _resolveDirective("clipboard")!
  const _directive_double_click_callback = _resolveDirective("double-click-callback")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["entity", 'entity-'+_ctx.type + ((_ctx.type==='sub1' && _ctx.params?.rules?.length) ? ' sub1-blocked': '') + (_ctx.busy?' entity-busy' : '')])
    }, [
      _withDirectives((_openBlock(), _createElementBlock("span", {
        class: "entity-id",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.id), 1)
      ])), [
        [_directive_clipboard]
      ]),
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("span", {
        class: "entity-name",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.name), 1)
      ])), [
        [_directive_clipboard]
      ])
    ], 2)), [
      [_directive_double_click_callback, {callback: _ctx.emitClick}]
    ])
  ], 512))
}